import Config from 'react-native-config';
import { Nullable } from 'modules/types/common';
import { RootState, RootDispatch } from 'store/types';
import { KEY } from '../types';
import { facetsDataSelector } from './selectors';
import {
  ProviderSpecialty,
  ProviderFacets,
  ProviderSpecialtiesPayload,
  ProviderFacetKeys
} from './types';

export const PROVIDER_FACETS = `${KEY}.PROVIDER_FACETS`;
export const PROVIDER_FACETS_FAIL = `${KEY}.PROVIDER_FACETS_FAIL`;
export const PROVIDER_FACETS_SUCCESS = `${KEY}.PROVIDER_FACETS_SUCCESS`;

export const providerFacets = () => (dispatch: RootDispatch, getState: () => RootState) => {
  if (facetsDataSelector(getState())) return;

  dispatch({
    type: PROVIDER_FACETS,
    payload: {
      client: 'azureProviderSearch',
      request: {
        method: 'get',
        url: `${Config.PROVIDER_URL_FACETS}?limit=200`
      }
    }
  });
};

export const PROVIDER_SPECIALTIES = `${KEY}.PROVIDER_SPECIALTIES`;
export const PROVIDER_SPECIALTIES_FAIL = `${KEY}.PROVIDER_SPECIALTIES_FAIL`;
export const PROVIDER_SPECIALTIES_SUCCESS = `${KEY}.PROVIDER_SPECIALTIES_SUCCESS`;

export const providerSpecialties = (payload: ProviderSpecialtiesPayload) => async (
  dispatch: RootDispatch,
  getState: () => RootState
) => {
  let facets: Nullable<ProviderFacets> = facetsDataSelector(getState());

  dispatch({ type: PROVIDER_SPECIALTIES });

  if (!facets) {
    const res = ((await dispatch(providerFacets)) as unknown) as {
      error?: string | Error;
      payload: { data: Nullable<ProviderFacets> };
    };

    if (res?.error) {
      dispatch({ type: PROVIDER_SPECIALTIES_FAIL, payload: res.error });
      return;
    }

    facets = res?.payload?.data;
  }

  if (!facets?.[ProviderFacetKeys.specialty]) {
    dispatch({ type: PROVIDER_SPECIALTIES_SUCCESS, payload: [] });
    return;
  }

  const specialties: ProviderSpecialty[] = facets[ProviderFacetKeys.specialty]
    .map(specialty => ({
      group: 'specialty',
      value: specialty.value
    }))
    .filter(specialty => specialty.value.toUpperCase().includes(payload.input.trim().toUpperCase()))
    .sort((a, b) => {
      const nameA = a.value.toUpperCase();
      const nameB = b.value.toUpperCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });

  dispatch({ type: PROVIDER_SPECIALTIES_SUCCESS, payload: specialties });
};
